import { render, staticRenderFns } from "./managePeople.vue?vue&type=template&id=646c6afe&"
import script from "./managePeople.vue?vue&type=script&lang=js&"
export * from "./managePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports